export default __webpack_public_path__ + "static/media/logo-icon-only.e5c4e529.svg";